<template>
	<div class="ciicWeb">
		<!-- 导航 -->
        <header :class="['web-home-nav', {'scroll-nav': isNavScroll }]" ref="nav">
            <div class="l-logo">
                <img class="h-img--f" src="@/assets/webImg/logo.png" alt="">
            </div>
            <div class="r-nav">
                <span class="r-nav-label" @click="handleJump('/ciicWeb/home')">首页</span>
                <span class="r-nav-label" @click="handleJump('/ciicWeb/product')">产品</span>
                <span class="r-nav-label" @click="handleJump('/ciicWeb/customerService')">客户服务</span>
                <span class="r-nav-label" @click="handleJump('/ciicWeb/latestNews')">最新资讯</span>
                <span class="r-nav-label" @click="handleJump('/ciicWeb/aboutUs')">关于我们</span>
                <span class="r-nav-login" @click="handleJump('/loginWeb')">登录</span>
            </div>    
        </header>

        <router-view></router-view>
  	</div>
</template>

<script>

import { setRem } from '@/util/commen.js'
export default {
	name: 'ciicWeb',

	data() {
		return {
			 isNavScroll: false,
		}
	},

	computed: {
      
    },

	created() {
		setRem()
	},

	mounted() {
		window.addEventListener("scroll", () => {
			if (document.documentElement.scrollTop > 50) {
				this.isNavScroll = true
			} else {
				this.isNavScroll = false

			}
		}, true)
	},

	methods: {
		handleJump(path) {
            this.$router.push({path})
        }
	}
}
</script>

<style lang="scss" scoped>
.ciicWeb {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 100px;
	.web-home-nav {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1001;
        box-sizing: border-box;
        width: 100%;
        height: 148px;
        padding: 0 100px;
        display: flex;
        justify-content: space-between;
        background: rgba(0, 0, 0, 0);
        transition: height .3s linear;
        .l-logo {
            width: 32.5%;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #FFFFFF;
            img {
                display: inline-block;
                width: 5rem;
            }
        }
        .r-nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            height: 100%;
            width: 67.5%;
            padding-left: 1.96rem;
            padding-right: 0.68rem;
            background: #004999;
            span {
                display: inline-block;
                font-size: 24px;
                font-weight: 500;
                color: #FFFFFF;
                cursor: pointer;
            }
            // .r-nav-label { padding-right: 94px; }
            .r-nav-login {
                width: 142px;
                height: 72px;
                border: 1px solid #FFFFFF;
                margin-left: 24px;
                // margin-right: ;
                line-height: 72px;
                border-radius: 38px;
                text-align: center;
            }
        }
    }
    .scroll-nav {
         height: 104px;
    }
}
</style>

